import { render, staticRenderFns } from "./MobileBlocker.vue?vue&type=template&id=19f91f70&scoped=true"
import script from "./MobileBlocker.vue?vue&type=script&lang=js"
export * from "./MobileBlocker.vue?vue&type=script&lang=js"
import style0 from "./MobileBlocker.vue?vue&type=style&index=0&id=19f91f70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f91f70",
  null
  
)

export default component.exports